module.exports = __webpack_public_path__ + "img/copy.ea06e11d.png";